<div class="container-fluid centerVertical">
  <div class="row">
    <div class="col-md-12 text-center espLogoCompany">
      <a href="https://energia.tracsa.com.mx/" target="_blank">
        <img class="imgMenuCompanies" src="/general/energia_logo.png" loading="lazy" />
      </a>
    </div>
    <div class="col-md-12 text-center espLogoCompany">
      <a href="https://rentalstore.tracsa.com.mx/" target="_blank" rel="noopener noreferrer">
        <img
          class="imgMenuCompanies"
          src="/general/logo_cat-rentals.svg"
          alt=""
          loading="lazy"
        />
      </a>
    </div>
    <div class="col-md-12 text-center espLogoCompany">
      <a href="https://sem.tracsa.com.mx/" target="_blank" rel="noopener noreferrer">
        <img
          class="imgMenuCompanies"
          src="/general/logo-SEM.svg"
          alt=""
          loading="lazy"
        />
      </a>
    </div>
    <div class="col-md-12 text-center espLogoCompany">
      <span class="fa-times" (click)="closeMenu()"><i class="iconTracsa icon-close">&#xe817;</i></span>
    </div>
  </div>
</div>
